(function(){
  function reveal(){
    var els=document.querySelectorAll('.z-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    els.forEach(function(e){io.observe(e)});
  }
  function sticky(){
    var btn=document.querySelector('.es-cart');
    if(!btn||document.querySelector('.z-atc')||!('IntersectionObserver' in window))return;
    var t=document.querySelector('.es-title'),p=document.querySelector('.es-curr');
    var bar=document.createElement('div');bar.className='z-atc';
    var info=document.createElement('div');info.className='z-atc__t';
    var name=document.createElement('span');name.textContent=t?t.textContent:'';
    var price=document.createElement('b');price.textContent=p?p.textContent:'';
    info.appendChild(name);info.appendChild(price);
    var b=document.createElement('button');b.type='button';
    function sync(){b.disabled=btn.disabled;b.textContent=btn.disabled?'Vyprodáno':'Přidat do košíku';if(p)price.textContent=p.textContent}
    sync();
    b.addEventListener('click',function(){btn.click()});
    bar.appendChild(info);bar.appendChild(b);document.body.appendChild(bar);
    new MutationObserver(sync).observe(document.querySelector('.es-info')||document.body,{attributes:true,childList:true,characterData:true,subtree:true});
    var io=new IntersectionObserver(function(es){var e=es[0];bar.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0)},{threshold:0});
    io.observe(btn);
  }
  function init(){reveal();sticky()}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  document.addEventListener('shopify:section:load',reveal);
})();
